(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2184],{

/***/ 41198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AcademyProduct; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/ui/Tag/Tag.tsx + 1 modules
var Tag = __webpack_require__(67279);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/AcademyProduct/AcademyProduct.elements.tsx



var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Item",
  componentId: "sc-110lsqg-0"
})(["margin-bottom:", ";width:100%;@media (min-width:", "px){display:flex;min-height:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(185));
var Calendar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Calendar",
  componentId: "sc-110lsqg-1"
})(["background:", ";display:flex;flex-direction:column;padding:", " ", ";position:relative;@media (min-width:", "px){width:", ";}"], function (prop) {
  return prop.isConference ? prop.theme.colors.primaryMedium : prop.theme.colors.primaryLight;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(195));
var Topic = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Topic",
  componentId: "sc-110lsqg-2"
})(["border:1px solid ", ";padding:", ";border-radius:", ";position:relative;width:100%;@media (min-width:", "px){padding:", ";}@media (min-width:", "px){display:flex;flex-direction:column;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(16), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md);
var TopicFirstRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__TopicFirstRow",
  componentId: "sc-110lsqg-3"
})(["display:flex;flex-direction:row;justify-content:space-between;padding-bottom:", ";font-weight:", ";.label{color:", ";font-size:", ";padding:", " ", ";font-weight:400;margin-left:", ";text-transform:uppercase;border-radius:", ";}.conferenceLabel{background:", ";}.courseLabel{background:", ";}"], (0,polished_esm/* rem */.hO)(15), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(16), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.black;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.dark;
});
var TopicSecondRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__TopicSecondRow",
  componentId: "sc-110lsqg-4"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(25));
var TopicThirdRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__TopicThirdRow",
  componentId: "sc-110lsqg-5"
})(["@media (min-width:", "px){display:flex;flex-direction:row;justify-content:space-between;align-items:flex-end;}"], theme/* breakpoints.sm */.A.sm);
var TopicTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "AcademyProductelements__TopicTitle",
  componentId: "sc-110lsqg-6"
})(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";color:", ";background:none;padding:0;border:none;cursor:pointer;text-align:left;text-decoration:none;display:inline-block;@media (min-width:", "px){width:70%;font-size:", ";line-height:", ";}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(24), function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeights.textBold;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.fontSecondary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.black;
}, theme/* breakpoints.sm */.A.sm, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontSizes.h5;
}, (0,polished_esm/* rem */.hO)(30));
var TopicDescription = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "AcademyProductelements__TopicDescription",
  componentId: "sc-110lsqg-7"
})(["line-clamp:3;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;margin:0;"]);
var Lecturers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Lecturers",
  componentId: "sc-110lsqg-8"
})(["display:flex;flex-wrap:wrap;max-width:80%;"]);
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductelements__Tags",
  componentId: "sc-110lsqg-9"
})(["padding:", " 0;@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.md */.A.md);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/AcademyProduct/AcademyProduct.tsx












var AcademyProductTemplate = function AcademyProductTemplate(_ref) {
  var _event$module2, _event$module3, _event$tags;

  var event = _ref.event;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();

  var buildRedirectPathname = function buildRedirectPathname() {
    var _event$module;

    return "".concat(constants/* ROUTES.ACADEMY_DETAIL */.Z6.ACADEMY_DETAIL, "/").concat((_event$module = event.module) === null || _event$module === void 0 ? void 0 : _event$module.slug);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Topic, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TopicFirstRow, {
        children: [moment_default()(event === null || event === void 0 ? void 0 : event.date_from).format('MM/YYYY'), " - ", moment_default()(event === null || event === void 0 ? void 0 : event.date_to).format('MM/YYYY')]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TopicSecondRow, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TopicTitle, {
          onClick: function onClick() {
            return router.push(buildRedirectPathname());
          },
          children: event === null || event === void 0 ? void 0 : (_event$module2 = event.module) === null || _event$module2 === void 0 ? void 0 : _event$module2.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TopicDescription, {
          dangerouslySetInnerHTML: {
            __html: event === null || event === void 0 ? void 0 : (_event$module3 = event.module) === null || _event$module3 === void 0 ? void 0 : _event$module3.annotation
          }
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TopicThirdRow, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Tags, {
            children: event === null || event === void 0 ? void 0 : (_event$tags = event.tags) === null || _event$tags === void 0 ? void 0 : _event$tags.map(function (tag, key) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
                name: tag.title,
                color: tag.color
              }, "tag-".concat(key));
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            marginTop: 10,
            onClick: function onClick() {
              return router.push({
                pathname: buildRedirectPathname()
              });
            },
            whiteType: true,
            text: t('homepage.calendar.button.detail')
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var AcademyProduct = (AcademyProductTemplate);

/***/ }),

/***/ 97461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ akademie; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/AcademyAdvantages/AcademyAdvantages.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__Wrapper",
  componentId: "sc-1kj7kqt-0"
})(["margin:", " 0 ", " 0;padding:", " 0;@media (min-width:", "px){display:flex;flex-direction:row;justify-content:space-between;}@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md);
var Sections = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__Sections",
  componentId: "sc-1kj7kqt-1"
})(["font-size:", ";display:flex;flex-direction:column;@media (min-width:", "px){width:45%;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, theme/* breakpoints.sm */.A.sm);
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__Section",
  componentId: "sc-1kj7kqt-2"
})(["margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(40));
var SectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__SectionHeader",
  componentId: "sc-1kj7kqt-3"
})(["display:flex;flex-direction:row;align-items:center;font-weight:", ";font-family:", ";svg{margin-right:", ";width:", ";height:", ";path{fill:", ";}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var SectionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyAdvantageselements__SectionDescription",
  componentId: "sc-1kj7kqt-4"
})(["padding-top:", ";margin-left:", ";color:", ";line-height:", ";"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(30), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(30));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/AcademyAdvantages/AcadamyAdvantages.tsx










var AcademyAdvantagesTemplate = function AcademyAdvantagesTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('academy.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section1.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('academy.advantages.section1.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section2.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('academy.advantages.section2.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section3.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('academy.advantages.section3.description')
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section4.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('academy.advantages.section4.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section5.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('academy.advantages.section5.description')
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Section, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionHeader, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
              name: Icon/* Icons.CheckThin */.PJ.CheckThin
            }), t('academy.advantages.section6.label')]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            children: t('academy.advantages.section6.description')
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var AcadamyAdvantages = (AcademyAdvantagesTemplate);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./src/components/AcademyProduct/AcademyProduct.tsx + 1 modules
var AcademyProduct = __webpack_require__(41198);
;// CONCATENATED MODULE: ./src/components/AcademyProducts/AcademyProducts.elements.tsx



var AcademyProducts_elements_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyProductselements__Wrapper",
  componentId: "sc-vhon6q-0"
})(["margin:", " 0 ", " 0;padding:", " 0;@media (min-width:", "px){display:flex;flex-direction:column;}@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md);
var EmptyMessage = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "AcademyProductselements__EmptyMessage",
  componentId: "sc-vhon6q-1"
})(["display:block;text-align:center;padding-bottom:", ";color:", ";line-height:", ";font-size:", ";"], (0,polished_esm/* rem */.hO)(40), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(30), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSizes.h6;
});
// EXTERNAL MODULE: ./src/components/Event/Event.tsx + 3 modules
var Event = __webpack_require__(76510);
;// CONCATENATED MODULE: ./src/components/AcademyProducts/AcademyProducts.tsx











var AcademyProductsTemplate = function AcademyProductsTemplate(_ref) {
  var _ref2, _ref2$sort;

  var events = _ref.events,
      eventsCount = _ref.eventsCount,
      courses = _ref.courses,
      coursesCount = _ref.coursesCount;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    mobileSidePadding: 20,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('academy.trainings.title')
    }), eventsCount > 0 || coursesCount > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(AcademyProducts_elements_Wrapper, {
      children: (_ref2 = [].concat((0,toConsumableArray/* default */.Z)(events), (0,toConsumableArray/* default */.Z)(courses))) === null || _ref2 === void 0 ? void 0 : (_ref2$sort = _ref2.sort(function (eventA, eventB) {
        var _eventA$dates, _eventA$dates$, _eventA$dates$$date, _eventB$dates, _eventB$dates$, _eventB$dates$$date;

        return new Date((eventA === null || eventA === void 0 ? void 0 : eventA.date_from) || (eventA === null || eventA === void 0 ? void 0 : (_eventA$dates = eventA.dates) === null || _eventA$dates === void 0 ? void 0 : (_eventA$dates$ = _eventA$dates[0]) === null || _eventA$dates$ === void 0 ? void 0 : (_eventA$dates$$date = _eventA$dates$.date) === null || _eventA$dates$$date === void 0 ? void 0 : _eventA$dates$$date.from)) < new Date((eventB === null || eventB === void 0 ? void 0 : eventB.date_from) || (eventB === null || eventB === void 0 ? void 0 : (_eventB$dates = eventB.dates) === null || _eventB$dates === void 0 ? void 0 : (_eventB$dates$ = _eventB$dates[0]) === null || _eventB$dates$ === void 0 ? void 0 : (_eventB$dates$$date = _eventB$dates$.date) === null || _eventB$dates$$date === void 0 ? void 0 : _eventB$dates$$date.from)) ? -1 : 1;
      })) === null || _ref2$sort === void 0 ? void 0 : _ref2$sort.map(function (event, key) {
        var isAcademy = !('people' in event);
        var isCourse = ('people' in event);

        if (isAcademy) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(AcademyProduct/* default */.Z, {
            event: event
          }, key);
        }

        if (isCourse) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Event/* default */.Z, {
            event: event
          }, key);
        }
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(EmptyMessage, {
      children: t('academy.trainings.emptyMessage')
    })]
  });
};

/* harmony default export */ var AcademyProducts = (AcademyProductsTemplate);
// EXTERNAL MODULE: ./src/components/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(90359);
// EXTERNAL MODULE: ./src/components/Header/Header.tsx + 2 modules
var Header = __webpack_require__(50866);
// EXTERNAL MODULE: ./src/ui/Hero/Hero.tsx + 1 modules
var Hero = __webpack_require__(29135);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
;// CONCATENATED MODULE: ./src/pages/akademie.tsx













var Academy = function Academy(_ref) {
  var events = _ref.events,
      eventsCount = _ref.eventsCount,
      courses = _ref.courses,
      coursesCount = _ref.coursesCount;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: t('seo.academy.title'),
      description: "",
      noindex: !constants/* IS_PROD */.XK,
      nofollow: !constants/* IS_PROD */.XK
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Hero/* default */.Z, {
      titleKey: "academy.hero.title",
      imageKey: "academy.webp",
      descriptionKey: "academy.hero.paragraph"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AcadamyAdvantages, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(AcademyProducts, {
      events: events,
      eventsCount: eventsCount,
      coursesCount: coursesCount,
      courses: courses
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
};

var __N_SSP = true;
/* harmony default export */ var akademie = (Academy);

/***/ }),

/***/ 29135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__Wrapper",
  componentId: "sc-1nsgps3-0"
})(["display:flex;padding:", " ", ";max-width:", ";margin:", " auto ", " auto;min-height:", ";flex-direction:column-reverse;@media (min-width:", "px){margin:", " auto ", " auto;}@media (min-width:", "px){flex-direction:row;align-items:center;padding:0;}"], (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(1180), (0,polished_esm/* rem */.hO)(constants/* MOBILE_HEADER_HEIGHT */.ZQ), (0,polished_esm/* rem */.hO)(40), (0,polished_esm/* rem */.hO)(500), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(constants/* DESKTOP_HEADER_HEIGHT */.cf), (0,polished_esm/* rem */.hO)(40), theme/* breakpoints.md */.A.md);
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Heroelements__Label",
  componentId: "sc-1nsgps3-1"
})(["font-size:", ";line-height:", ";display:flex;margin-bottom:", ";svg{width:", ";height:", ";margin-right:", ";margin-top:", ";polyline{stroke:black;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(26), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(2));
var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Heroelements__Image",
  componentId: "sc-1nsgps3-2"
})(["width:100%;border-radius:", ";height:auto;margin-top:", ";@media (min-width:", "px){display:block;margin-top:", ";width:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(600));
var About = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Heroelements__About",
  componentId: "sc-1nsgps3-3"
})(["@media (min-width:", "px){padding-left:", ";}"], theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(65));
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Heroelements__Title",
  componentId: "sc-1nsgps3-4"
})(["font-weight:", ";font-size:", ";font-family:", ";padding-bottom:", ";@media (min-width:", "px){font-size:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.h3;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontSizes.h2;
});
var Description = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Heroelements__Description",
  componentId: "sc-1nsgps3-5"
})(["font-size:", ";font-weight:", ";padding:", " 0 ", " 0;line-height:", ";color:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.h6;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeights.textRegular;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(30), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.grey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Hero/Hero.tsx









var HeroTemplate = function HeroTemplate(_ref) {
  var titleKey = _ref.titleKey,
      imageKey = _ref.imageKey,
      descriptionKey = _ref.descriptionKey,
      listKeys = _ref.listKeys;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      src: (0,url_utils/* publicAssets */.VK)("/".concat(imageKey))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(About, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        dangerouslySetInnerHTML: {
          __html: t(titleKey)
        }
      }), descriptionKey && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
        dangerouslySetInnerHTML: {
          __html: t(descriptionKey)
        }
      }), (listKeys === null || listKeys === void 0 ? void 0 : listKeys.length) > 0 && (listKeys === null || listKeys === void 0 ? void 0 : listKeys.map(function (listKey, key) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Label, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconTemplate/* IconTemplate */._, {
            name: Icon/* Icons.CheckThin */.PJ.CheckThin
          }), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            dangerouslySetInnerHTML: {
              __html: t(listKey)
            }
          })]
        }, key);
      }))]
    })]
  });
};

/* harmony default export */ var Hero = (HeroTemplate);

/***/ }),

/***/ 83297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TitleTagTypes; },
  "C": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.element.tsx



var TitleStyles = (0,styled_components_browser_esm/* css */.iv)(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";padding:", ";", ";@media (min-width:", "px){", ";padding:", ";font-size:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h4;
}, (0,polished_esm/* rem */.hO)(40), function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0");
}, function (prop) {
  return prop.isBlack ? "color: ".concat(prop.theme.colors.black) : "color: ".concat(prop.theme.colors.primary);
}, theme/* breakpoints.sm */.A.sm, function (prop) {
  return prop.alignLeft ? 'text-align: left' : 'text-align: center';
}, function (prop) {
  return prop.withoutPadding ? 0 : "".concat((0,polished_esm/* rem */.hO)(20), " 0 ").concat((0,polished_esm/* rem */.hO)(45), " 0");
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontSizes.h3;
});
var WrapperDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Titleelement__WrapperDiv",
  componentId: "sc-s8z71i-0"
})(["", ""], TitleStyles);
var WrapperH1 = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "Titleelement__WrapperH1",
  componentId: "sc-s8z71i-1"
})(["", ""], TitleStyles);
var WrapperH2 = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Titleelement__WrapperH2",
  componentId: "sc-s8z71i-2"
})(["", ""], TitleStyles);
var WrapperH3 = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Titleelement__WrapperH3",
  componentId: "sc-s8z71i-3"
})(["", ""], TitleStyles);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/SectionTitle/Title.tsx



var TitleTagTypes;

(function (TitleTagTypes) {
  TitleTagTypes["H1"] = "h1";
  TitleTagTypes["H2"] = "h2";
  TitleTagTypes["H3"] = "h3";
})(TitleTagTypes || (TitleTagTypes = {}));

var TitleTemplate = function TitleTemplate(_ref) {
  var children = _ref.children,
      alignLeft = _ref.alignLeft,
      withoutPadding = _ref.withoutPadding,
      isBlack = _ref.isBlack,
      tagType = _ref.tagType;

  if (tagType === TitleTagTypes.H1) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH1, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H3) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH3, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  if (tagType === TitleTagTypes.H2) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperH2, {
      withoutPadding: withoutPadding,
      alignLeft: alignLeft,
      isBlack: isBlack,
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(WrapperDiv, {
    withoutPadding: withoutPadding,
    alignLeft: alignLeft,
    isBlack: isBlack,
    children: children
  });
};

/* harmony default export */ var Title = (TitleTemplate);

/***/ }),

/***/ 13994:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/akademie",
      function () {
        return __webpack_require__(97461);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4913,354,5675,5897,6510,9774,2888,179], function() { return __webpack_exec__(13994); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);